import { message } from "antd";
import { useTranslation } from "react-i18next";
import UserIcon from "../../../assets/icons/user-grey-bg.svg";
import ArrowChatIcon from "../../../assets/icons/arrow-chat.svg";
import { useEffect, useState } from "react";
import { blockService } from "../../../services";
import { useNavigate } from "react-router-dom";
import { convertToShortDate } from "../../../utls/FunctionsUtil";
import UserIsBlockedModalComponent from "../../../components/UserIsBlockedModalComponent";
import { useDispatch } from "react-redux";
import { clearAllConversations, clearSelectedConversation } from "../../../redux/messages/messagesSlice";

const BlockedFansList = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [blockedFansList, setBlockedFansList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedFanId, setSelectedFanId] = useState<string | null>(null);
  const [isUnblockModalOpen, setIsUnblockModalOpen] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();


  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const blockedList = await blockService.getBlockedFansList();
      setBlockedFansList(blockedList);

    } catch (error) {
      messageApi.error(typeof error === "string" ? error : t("error-occurred"));
    } finally {
      setLoading(false);
    }
  };

  async function handleUnblockFan() {
    if (!selectedFanId) return;

    await blockService.unblockFan(selectedFanId)
      .then(() => {
        message.success(t("fan-unblocked-success"));
        setIsUnblockModalOpen(false);

        dispatch(clearSelectedConversation());
        dispatch(clearAllConversations());
        fetchData();
      })
      .catch((error) => {
        message.error(typeof error === "string" ? error : t("something-went-wrong"));
      });
  }


  return (
    <>
      <div className="invitation-manager-page">
        {contextHolder}
        <img width={11} src={ArrowChatIcon} alt="Back" onClick={() => navigate(-1)} />
        <h1 className="invitation-manager-title">{t("blocked-fans-list")}</h1>
        <div className="invitation-manager-wrapper">
          {loading ? (
            <div className="invitation-manager-loading">{t("loading")}</div>
          ) : blockedFansList.length > 0 ? (
            blockedFansList.map((fan: any) => (
              <div className="invitation-manager-content" key={fan._id} onClick={() => {
                setSelectedFanId(fan._id);
                setIsUnblockModalOpen(true);
              }}>
                <img src={UserIcon} alt="User" />
                <div className="invitation-manager-content-info">
                  <div className="invitation-manager-content-info-name">
                    {`${fan?.name} . @${fan?.username}`}
                  </div>
                  <div className="invitation-manager-content-info-date">{t("blocked-since", { date: fan.blockedSince ? convertToShortDate(fan.blockedSince, "fr-FR") : "" })}</div>
                </div>
              </div>
            ))
          ) : (
            <div className="invitation-manager-no-content">{t("no-blocked-fans")}</div>
          )}
        </div>
      </div>

      <UserIsBlockedModalComponent
        isOpen={isUnblockModalOpen}
        onClose={() => setIsUnblockModalOpen(false)}
        unblockFan={handleUnblockFan}
      />
    </>
  )
};

export default BlockedFansList;
